export const dbConfig = {
	organisation: {
		hasMany: ['environment', 'billingInfo'],
	},
	user: {
		hasMany: ['userEmploymentType', 'workSchedule', 'contractHolder', 'salary', 'team', 'environment', 'organisation'],
		bidirectionalRelations: ['team', 'environment'],
	},
	environment: {
		hasMany: ['role'],
	},
	billingInfo: {
		hasMany: ['environment'],
	},
	billingInvoice: {
		hasMany: ['environment'],
	},
	post: {
		hasMany: ['team'],
	},
	integrationExtEnvironment: {
		hasMany: ['environment', 'integrationExtRevenueGroup'],
	},
	integrationBaseConnection: {
		hasMany: ['integrationExtEnvironment'],
	},
	omzetGroep: {
		hasMany: ['integrationExtRevenueGroup'],
	},
	timeRegistrationShift: {
		hasMany: ['checkIn'],
	},
	skillSet: {
		bidirectionalRelations: ['skill'],
	},
	roosterTemplate: {
		hasMany: ['team', 'environment'],
	},
	topic: {
		hasMany: ['info', 'quizItem'],
	},
	info: {
		hasMany: ['topic'],
	},
}
